//Reference: EN118

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Region extends Mappeable {
    idRegionPk: number;
    txtRegion: string;
    areaTerritorial: any;
    mrkActive: boolean;


    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtRegion: this.txtRegion,
            areaTerritorial: this.areaTerritorial,
            mrkActive: this.mrkActive
        }
    }


}